module.exports = __webpack_public_path__ + "static/media/vidthumbnail2.8c98d0c4.jpg";